import { z } from 'zod';

export const heroDarkSchema = z.object({
  videoSrc: z.string().min(1).max(1000).optional(),
  posterSrc: z.string().min(1).max(1000).optional(),
  h1Top: z.string().max(160).optional(),
  h1Highlight: z.string().min(1).max(160),
  h1Mute: z.string().max(160).optional(),
  sub: z.string().max(600).optional(),
  ctaPrimary: z
    .object({
      label: z.string().min(1).max(80),
      href: z.string().min(1).max(500),
    })
    .optional(),
  ctaSecondary: z
    .object({
      label: z.string().min(1).max(80),
      href: z.string().min(1).max(500),
    })
    .optional(),
  miniStats: z
    .array(
      z.object({
        value: z.string().min(1).max(40),
        label: z.string().min(1).max(120),
      }),
    )
    .max(6)
    .optional(),
  showScrollCue: z.boolean().default(true),
});

export type HeroDarkData = z.infer<typeof heroDarkSchema>;
